import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Customer} from "../../../../../shared/model/customer";
import {HttpCustomService} from "../../../../../service/http-custom.service";
import * as moment from 'moment';
import {API} from "../../../../../shared/apis/api";
import {take, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs/Rx";
import {MeterData} from "../../../../../shared/model/meter-data.model";
import {MeterDataHistory} from "../../../../../shared/model/meter-data-history.model";
import {FormControl} from "@angular/forms";

@Component({
  selector: 'omni-current-meter-data',
  templateUrl: './current-meter-data.component.html',
  styleUrls: ['./current-meter-data.component.scss']
})
export class CurrentMeterDataComponent implements OnInit, OnDestroy {
  @Input() customer: Customer;
  ngUnsubscribe: Subject<any> = new Subject();
  meterData: MeterData;
  meterDataHistoryList: MeterDataHistory[] = [];
  maxDate = new Date();
  minDate = moment().subtract(7, 'months').toDate();
  date: FormControl = new FormControl();

  constructor(
    private http: HttpCustomService
  ) { }

  ngOnInit(): void {
    this.getMeterDataHistory();
  }

  private getMeterData(date: string) {
    const body = {
      'measuringPointCode': this.customer.measuringPointCode,
      'meterCode': this.customer.meterCode,
      'date': date,
      'meterSample': this.customer.meterSample
    }
    this.http.post({path: API.CUSTOMER_METER_DATA_VIEW}, body)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res) {
          this.meterData = res;
        }
      });
  }

  private getMeterDataHistory() {
    this.http.get({path: API.CUSTOMER_METER_DATA_HISTORY}, {'customer-no': this.customer.customerNo})
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.meterDataHistoryList = res;
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  changeDate(value) {
    if (value) {
      const selectedDate = moment(value).format('MM/DD/YYYY');
      this.getMeterData(selectedDate);
    }
  }
}
